export default {
    REGISTER_TEXT: 'onb_tarjeta_credito_registro_text',
    REGISTER_TOOLTIP: 'onb_tarjeta_credito_registro_tooltip',
    ADDITIONAL_TEXT: 'onb_tarjeta_credito_additional_text',
    ADDITIONAL_TOOLTIP: 'onb_tarjeta_credito_additional_tooltip',
    JAFFAR_TEXT: 'onb_tarjeta_credito_jaffar_text',
    JAFFAR_TOOLTIP: 'onb_tarjeta_credito_jaffar_tooltip',
    NOMINA_TEXT: 'onb_tarjeta_credito_nomina',
    NO_NOMINA_TEXT: 'onb_tarjeta_credito_no_nomina',
    STANDBY_FINAL: 'onb_tarjeta_credito_standby_final',
};
